import { render, staticRenderFns } from "./goods-to-price-set.vue?vue&type=template&id=678b25e2&scoped=true&"
import script from "./goods-to-price-set.vue?vue&type=script&lang=js&"
export * from "./goods-to-price-set.vue?vue&type=script&lang=js&"
import style0 from "./goods-to-price-set.vue?vue&type=style&index=0&id=678b25e2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "678b25e2",
  null
  
)

export default component.exports